export const SHOW_BREADCRUMBS_LOGIN = 'breadcrumbs/SHOW_BREADCRUMBS_LOGIN';

export const showBreadcrumbsLogin = payload => ({
  type: SHOW_BREADCRUMBS_LOGIN,
  payload,
});



// WEBPACK FOOTER //
// ./app/actions/show-breadrumbs-login.js